import { render, staticRenderFns } from "./tableDescriptionDebentures.vue?vue&type=template&id=63599aa4&scoped=true"
import script from "./tableDescriptionDebentures.vue?vue&type=script&lang=js"
export * from "./tableDescriptionDebentures.vue?vue&type=script&lang=js"
import style0 from "./tableDescriptionDebentures.vue?vue&type=style&index=0&id=63599aa4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63599aa4",
  null
  
)

export default component.exports